import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { HorizontalNav } from 'containers';
import { connect } from 'react-redux';
import * as styles from './ScrollableRow.scss';
var ScrollableRow = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ScrollableRow, _Component);

  var _super = _createSuper(ScrollableRow);

  function ScrollableRow(props) {
    var _this;

    _classCallCheck(this, ScrollableRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      window.addEventListener('resize', _this.handleResize);

      var _innerWrapWidth = nextProps.itemWidth * nextProps.items.length;

      _this.setState({
        innerWrapWidth: _innerWrapWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.handleResize);
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {// this.setState({ width: 0 });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftClick", function () {
      _this.setState({
        left: _this.state.left + _this.state.width
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightClick", function () {
      _this.setState({
        left: _this.state.left - _this.state.width
      });
    });

    _defineProperty(_assertThisInitialized(_this), "incrementPage", function () {
      _this.removePopover();

      _this.setState({
        offsetIndex: _this.state.offsetIndex + 1 < _this.state.maxOffsetIndex ? _this.state.offsetIndex + 1 : _this.state.offsetIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementPage", function () {
      _this.removePopover();

      _this.setState({
        offsetIndex: _this.state.offsetIndex - 1 > 0 ? _this.state.offsetIndex - 1 : 0
      });
    });

    _this.state = {
      offsetIndex: 0,
      offsetAmount: 500,
      maxOffsetIndex: 0,
      left: 0,
      width: 100,
      innerWrapWidth: 10000
    };
    return _this;
  }

  _createClass(ScrollableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log('width');
      console.log(this.state.width);
      console.log('innerWrapWidth');
      console.log(this.state.innerWrapWidth);
      var atEnd = this.state.width > this.state.innerWrapWidth || this.state.innerWrapWidth + this.state.left < this.state.width;
      var offsetStyle = {
        left: -this.state.offsetAmount * this.state.offsetIndex
      };
      return /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          "float": 'left',
          width: '100%'
        })
      }, /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['width'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            width: dimensions.width - 150
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: {
          width: '100%',
          height: this.props.itemHeight
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rowHeaderWrap,
        style: this.state.left !== 0 ? {
          boxShadow: '4px 0 4px -4px rgba(0,0,0,0.5)',
          height: this.props.itemHeight
        } : {
          height: this.props.itemHeight
        }
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.rowHeader
      }, this.props.rowTitle)), /*#__PURE__*/React.createElement("div", {
        className: styles.outerWrap,
        style: {
          width: this.state.width,
          height: this.props.itemHeight
        }
      }, this.state.left !== 0 && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.leftControl),
        onClick: this.handleLeftClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back"
      })), !atEnd && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.rightControl),
        onClick: this.handleRightClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap,
        style: {
          display: 'flex',
          left: this.state.left,
          width: this.state.innerWrapWidth
        }
      }, this.props.items)))));
    }
  }]);

  return ScrollableRow;
}(Component), _defineProperty(_class2, "propTypes", {
  rowData: PropTypes.array.isRequired,
  rowTitle: PropTypes.string.isRequired,
  style: PropTypes.object
}), _temp)) || _class);
export { ScrollableRow as default };